import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import {
  Box,
  Drawer,
  useMediaQuery,
  List,
  Typography,
  ListItem,
  Collapse,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import FeatherIcon from "feather-icons-react";
import { SidebarWidth } from "../../../assets/global/Theme-variable";
import LogoIcon from "../logo/LogoIcon";
import Menuitems from "./Menuitems";
// import Buynow from './Buynow';
import Scrollbar from "../../../components/custom-scroll/Scrollbar";
import { useAuth } from "../../../authentication/AuthProvider";

const Sidebar = ({ isMobileSidebarOpen, onSidebarClose, isSidebarOpen }) => {
  const [open, setOpen] = React.useState(true);
  const { pathname } = useLocation();
  const pathDirect = pathname;
  const pathWithoutLastPart = pathname.slice(0, pathname.lastIndexOf("/"));
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));

  const auth = useAuth();

  const handleClick = (index) => {
    setOpen(open === index ? -1 : index);
  };

  const SidebarContent = (
    <Scrollbar style={{ height: "calc(100vh - 5px)" }}>
      <Box sx={{ mt: 2, ml: -2, p: 2 }}>
        <Box sx={{ mt: 2, ml: 1, textAlign: "center" }}>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

            <Box sx={{ transform: "scale(1.5)" }}>
              <LogoIcon />
            </Box>

            <Typography fontWeight="500" sx={{ mt: 1 }}>
              S.S White Technology
            </Typography>

          </Box>
        </Box>
        <Box>
          <List>
            {/* {Menuitems.map((item, index) => { */}
            {Menuitems.filter((x) => x.display).map((item, index) => {

              const isParentActive =
                item.children?.some(
                  (child) =>
                    pathDirect === child.href ||
                    child?.subChild?.href?.some(
                      (x) => x === pathDirect || x === pathWithoutLastPart
                    )
                );

              // {/********SubHeader**********/}
              if (item.subheader) {
                return (
                  <li key={item.subheader}>
                    <Typography
                      variant="subtitle2"
                      fontWeight="600"
                      sx={{ my: 2, mt: 4, ml: 2, color: (theme) => theme.palette.primary.main }}
                    >
                      {item.subheader}
                    </Typography>
                  </li>
                );
                // {/********If Sub Menu**********/}
                /* eslint no-else-return: "off" */
              } else if (item.children) {
                return (
                  <React.Fragment key={item.title}>
                    <ListItem
                      button
                      component="li"
                      onClick={() => handleClick(index)}
                      selected={isParentActive}
                      sx={{
                        mb: 1,
                        ml: 1,
                        ...(isParentActive && {
                          color: "white",
                          backgroundColor: (theme) =>
                            `${theme.palette.primary.main}!important`,
                        }),
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          ...(isParentActive && {
                            color: "white",
                          }),
                        }}
                      >
                        <FeatherIcon icon={item.icon} width="20" height="20" />
                      </ListItemIcon>
                      <ListItemText>{item.title}</ListItemText>
                      {index === open ? (
                        <FeatherIcon icon="chevron-down" size="16" />
                      ) : (
                        <FeatherIcon icon="chevron-right" size="16" />
                      )}
                    </ListItem>
                    <Collapse in={index === open} timeout="auto" unmountOnExit>
                      <List component="li" disablePadding>
                        {item.children
                          .filter((x) => x.display)
                          .map((child) => {
                            // --- CHANGED: Use <a> for external links, <NavLink> for internal ---
                            if (child.href && child.href.startsWith("http")) {
                              return (
                                <ListItem
                                  key={child.title}
                                  button
                                  component="a"
                                  href={child.href}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  onClick={onSidebarClose}
                                  sx={{
                                    mb: 1,
                                    ml: 1,
                                  }}
                                >
                                  <ListItemIcon
                                    sx={{
                                      svg: { width: "14px", marginLeft: "3px" },
                                    }}
                                  >
                                    <FeatherIcon
                                      icon={child.icon}
                                      width="20"
                                      height="20"
                                    />
                                  </ListItemIcon>
                                  <ListItemText>
                                    {child.title}
                                    {child?.isCount
                                      ? ` (${auth.MPCVoteCount})`
                                      : ""}
                                    {child?.isTotal
                                      ? ` (${auth?.documentAwaitingCount})`
                                      : ""}
                                  </ListItemText>
                                </ListItem>
                              );
                            } else {
                              return (
                                <ListItem
                                  key={child.title}
                                  button
                                  component={NavLink}
                                  to={child.href}
                                  onClick={onSidebarClose}
                                  selected={
                                    pathDirect === child.href ||
                                    child?.subChild?.href.some(
                                      (x) => x === pathDirect || x === pathWithoutLastPart
                                    )
                                  }
                                  sx={{
                                    mb: 1,
                                    ml: 1,
                                    ...((pathDirect === child.href ||
                                      child?.subChild?.href.some(
                                        (x) => x === pathDirect || x === pathWithoutLastPart
                                      )) && {
                                      color: "white",
                                      backgroundColor: (theme) =>
                                        `${theme.palette.primary.main}!important`,
                                    }),
                                  }}
                                >
                                  <ListItemIcon
                                    sx={{
                                      svg: { width: "14px", marginLeft: "3px" },
                                      ...((pathDirect === child.href ||
                                        child?.subChild?.href.some(
                                          (x) => x === pathDirect || x === pathWithoutLastPart
                                        )) && {
                                        color: "white",
                                      }),
                                    }}
                                  >
                                    <FeatherIcon
                                      icon={child.icon}
                                      width="20"
                                      height="20"
                                    />
                                  </ListItemIcon>
                                  <ListItemText>
                                    {child.title}
                                    {child?.isCount
                                      ? ` (${auth.MPCVoteCount})`
                                      : ""}
                                    {child?.isCountMyApproval
                                      ? `(${auth.mpcAllVoteForEpoCount})`
                                      : ""}
                                    {child?.isTotal
                                      ? ` (${auth?.documentAwaitingCount})`
                                      : ""}
                                  </ListItemText>
                                </ListItem>
                              );
                            }
                          })}
                      </List>
                    </Collapse>
                  </React.Fragment>
                );
                // {/********If Sub No Menu**********/}
              } else {
                return (
                  <List component="li" disablePadding key={item.title}>
                    {item.href && item.href.startsWith("http") ? (
                      <ListItem
                        button
                        component="a"
                        href={item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          mb: 1,
                          ml: 1,
                        }}
                      >
                        <ListItemIcon>
                          <FeatherIcon icon={item.icon} width="20" height="20" />
                        </ListItemIcon>
                        <ListItemText onClick={onSidebarClose}>
                          {item.title}
                        </ListItemText>
                      </ListItem>
                    ) : (
                      <ListItem
                        onClick={() => handleClick(index)}
                        button
                        component={NavLink}
                        to={item.href}
                        selected={pathDirect === item.href}
                        sx={{
                          mb: 1,
                          ml: 1,
                          ...(pathDirect === item.href && {
                            color: "white",
                            backgroundColor: (theme) =>
                              `${theme.palette.primary.main}!important`,
                          }),
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            ...(pathDirect === item.href && { color: "white" }),
                          }}
                        >
                          <FeatherIcon icon={item.icon} width="20" height="20" />
                        </ListItemIcon>
                        <ListItemText onClick={onSidebarClose}>
                          {item.title}
                        </ListItemText>
                      </ListItem>
                    )}
                  </List>
                );
              }
            })}
          </List>
        </Box>
        {/* <Buynow /> */}
      </Box>
    </Scrollbar>
  );
  if (lgUp) {
    return (
      <Drawer
        anchor="left"
        open={isSidebarOpen}
        variant="persistent"
        PaperProps={{
          sx: {
            width: SidebarWidth,
            border: "0 !important",
            boxShadow: "0px 7px 30px 0px rgb(113 122 131 / 11%)",
          },
        }}
      >
        {SidebarContent}
      </Drawer>
    );
  }
  return (
    <Drawer
      anchor="left"
      open={isMobileSidebarOpen}
      onClose={onSidebarClose}
      PaperProps={{
        sx: {
          width: SidebarWidth,
          border: "0 !important",
        },
      }}
      variant="temporary"
    >
      {SidebarContent}
    </Drawer>
  );
};

Sidebar.propTypes = {
  isMobileSidebarOpen: PropTypes.bool,
  onSidebarClose: PropTypes.func,
  isSidebarOpen: PropTypes.bool,
};

export default Sidebar;
